import { useState, useEffect } from 'react';
import Modal from './ModalConversion';
import FileUploaderReport from './FileUploaderReport';

function UploadReport({ showUpload, setShowUpload, channels, onUploadSuccess }) {
    const [show, setShow] = useState(false);
    const [selectedChannel, setSelectedChannel] = useState('');

    const handleClose = () => {
        setShow(false);
        setShowUpload(false);
        setSelectedChannel('');
    };

    useEffect(() => {
        if (showUpload === true)
            setShow(true);
    }, [showUpload]);

    const handleChannelChange = (e) => {
        setSelectedChannel(e.target.value);
    };

    return (
        <Modal isOpen={show} onClose={handleClose}>
            <div className="p-3">
                <h3 className="mb-4 text-white">Cargar Reporte de Tienda</h3>

                <div className="mb-3">
                    <label className="form-label text-white">Seleccionar Tienda</label>
                    <select
                        className="form-select bg-dark text-white border-secondary py-2"
                        value={selectedChannel}
                        onChange={handleChannelChange}
                    >
                        <option value="">-- Selecciona una tienda --</option>
                        {channels.map((channel) => (
                            <option key={channel.alias} value={channel.alias}>
                                {channel.name}{/*  ({channel.config_report?.file_type?.toUpperCase()}) */}
                            </option>
                        ))}
                    </select>
                    {selectedChannel && (
                        <small className="text-white-50">
                            Formato esperado: {channels.find(ch => ch.alias === selectedChannel)?.config_report?.file_type?.toUpperCase()}
                        </small>
                    )}
                </div>
                {selectedChannel && (
                    <FileUploaderReport
                        channel={selectedChannel}
                        onClose={handleClose}
                        onUploadSuccess={onUploadSuccess}
                    />
                )}

                <div className="d-flex justify-content-end mt-4 pt-3 border-top border-secondary">
                    <button type="button" className="btn btn-outline-secondary px-4" onClick={handleClose}>
                        Cerrar
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default UploadReport;
